import Markdown from '@/common/atoms/Markdown'
import { Box, BoxProps, Text, Textarea } from '@chakra-ui/react'
import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ReleaseItemRow } from '../releaseBoard'

interface Props extends BoxProps {
  item: ReleaseItemRow
  isDragging: boolean
  // Set when the card is in « to adjust »: its text becomes editable
  edited?: string
  onEdit?(text: string): void
}

// #77 — one ticket of a release in the console, styled as the cards of the
// compte rendu sharing board: the ticket for Yohan, then the text members read.
const AdminReleaseCard = forwardRef<HTMLDivElement, Props>(
  function AdminReleaseCard(
    { item, isDragging, edited, onEdit, ...boxProps },
    ref
  ) {
    const { t } = useTranslation()

    return (
      <Box
        ref={ref}
        p={3}
        bg="white"
        _dark={{ bg: 'blackAlpha.500' }}
        borderRadius="md"
        borderWidth={1}
        boxShadow={isDragging ? 'lg' : 'sm'}
        transition="box-shadow 200ms ease-out"
        _hover={{ boxShadow: 'md' }}
        {...boxProps}
      >
        <Text fontSize="xs" color="gray.500" _dark={{ color: 'gray.300' }}>
          {item.ticket
            ? `#${item.ticket} · ${item.ticketTitle ?? ''}`
            : t('SuperAdmin.releases.noTicket')}
        </Text>

        {edited !== undefined && onEdit ? (
          <>
            <Text mt={1} fontSize="xs" color="gray.500" as="s">
              {item.proposedText}
            </Text>
            <Textarea
              mt={2}
              size="sm"
              value={edited}
              aria-label={t('SuperAdmin.releases.editText')}
              onChange={(event) => onEdit(event.target.value)}
              // Typing must not start a drag
              onMouseDown={(event) => event.stopPropagation()}
            />
          </>
        ) : (
          <Box mt={1} fontSize="sm">
            <Markdown>{item.proposedText}</Markdown>
          </Box>
        )}
      </Box>
    )
  }
)

export default AdminReleaseCard
